import './index.scss';
import { FC } from 'react';
import { Moment } from 'moment';
import { useSelector } from 'react-redux';
import { createTheme, Button, Card } from '@material-ui/core';
import { ThemeProvider } from '@material-ui/styles';
import { DatePicker } from '@components/SharedComponents/DesignSystem/Inputs';
import { translate } from '@utils';
import { AnswerQueryInterface, MgState } from '@types';

const defaultMaterialTheme = createTheme({
  palette: {
    primary: {
      main: '#eb3d26',
    },
  },
});

interface Props {
  selectedDateFrom: Moment;
  selectedDateTo: Moment;
  handleDateChange: (value: Moment, type: 'from' | 'to') => void;
  handleClearButtonClick: () => void;
  handleSaveButtonClick: () => void;
}

export const DateFilter: FC<Props> = ({
  selectedDateFrom,
  selectedDateTo,
  handleDateChange,
  handleClearButtonClick,
  handleSaveButtonClick,
}) => {
  const answersFilter = useSelector<MgState, AnswerQueryInterface>(
    ({ answersPage }) => answersPage.filters
  );
  const { isDateFromSaved, isDateToSaved } = useSelector((state: MgState) => state.answer);
  const dateFrom = !isDateFromSaved ? selectedDateFrom : answersFilter.from;
  const dateTo = !isDateToSaved ? selectedDateTo : answersFilter.to;

  return (
    <Card data-testid="date-filter">
      <div className="date-filter">
        <div className="date-filter__title">{translate('sort_by_date')}</div>
        <div className="date-filter__container">
          <div className="date-filter__item">
            <div className="date-filter__from">{translate('from')}</div>
            <div>
              <ThemeProvider theme={defaultMaterialTheme}>
                <DatePicker
                  testId="datepicker-from"
                  value={dateFrom as Moment}
                  maxDate={selectedDateTo}
                  onChange={(value) => {
                    handleDateChange(value, 'from');
                  }}
                />
              </ThemeProvider>
            </div>
          </div>
          <div className="date-filter__item">
            <div className="date-filter__to">{translate('to')}</div>
            <div>
              <ThemeProvider theme={defaultMaterialTheme}>
                <DatePicker
                  testId="datepicker-to"
                  // TODO: Fix it
                  value={dateTo as Moment}
                  minDate={selectedDateFrom}
                  onChange={(value) => {
                    handleDateChange(value, 'to');
                  }}
                />
              </ThemeProvider>
            </div>
          </div>
        </div>
        <div className="date-filter__actions">
          <div className="save-button">
            <Button
              data-testid="save-button"
              size="large"
              color="secondary"
              onClick={handleSaveButtonClick}
              disableRipple
            >
              {translate('save')}
            </Button>
          </div>
          <div className="clear-button">
            <Button size="large" color="secondary" onClick={handleClearButtonClick} disableRipple>
              {translate('clear')}
            </Button>
          </div>
        </div>
      </div>
    </Card>
  );
};
